module.exports = __webpack_public_path__ + "img/Frutos Mumificados com Esporodóquios e Peritécios3.2aab5829.webp";